export default "/images/b4abd19a928ac10a7e8872e6eb63aa36.avif";